<template>
  <el-card>
    <div class="toolbar">
      <el-button type="text" @click="$router.back()"
        ><i class="fas fa-chevron-left"></i> 返回</el-button
      >
      <el-button type="primary" size="small" @click="addGroupVisible = true"
        ><i class="fas fa-plus"></i> 添加分组</el-button
      >
      <div class="pull-right search-area">
        <div class="box-inline" style="width: 200px; vertical-align: middle">
          <el-input
            v-model="queryFormBind['Name:like']"
            placeholder="搜索分组名称"
            @keyup.enter.native="onSubmitQuery"
          ></el-input>
        </div>
        &nbsp;
        <el-button size="small" @click="onSubmitQuery" title="搜索">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>

    <el-table :data="groupList">
      <el-table-column
        type="index"
        :index="15 * (currentPage - 1) + 1"
        width="52"
      ></el-table-column>
      <el-table-column prop="Name" label="分组名称" width="250">
        <template scope="scope">
          <span class="text-overflow" :title="scope.row.name">{{
            scope.row.Name
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="Clients"
        label="设备数量"
        width="120"
      ></el-table-column>
      <el-table-column prop="Content" label="分组说明">
        <template scope="scope">
          <span class="text-overflow" :title="scope.row.content">{{
            scope.row.Content
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template scope="scope">
          <div class="text-nowrap">
            <el-button
              type="primary"
              size="small"
              title="编辑"
              @click="onEditClient(scope.row)"
              style="width: 33px"
            >
              <i class="fas fa-edit"></i>
            </el-button>
            <el-button
              type="danger"
              size="small"
              title="删除"
              @click="onDeleteGroup(scope.row.ID)"
              style="width: 33px"
            >
              <i class="fas fa-trash"></i>
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top">
      <el-pagination
        class="pull-right"
        @current-change="changePage"
        layout="total, prev, pager, next"
        :total="totalItem"
        :current-page="currentPage"
        :page-size="15"
      >
      </el-pagination>
    </div>

    <el-dialog
      :visible="addGroupVisible"
      :title="isEdit ? '修改分组数据' : '创建新的分组'"
      :close-on-click-modal="false"
      @close="resetAddGroup"
    >
      <el-form
        :model="addGroup"
        ref="addGroup"
        label-width="90px"
        :rules="groupRules"
      >
        <el-form-item label="分组名称" prop="Name">
          <el-input
            v-model="addGroup.Name"
            placeholder="请输入分组名"
          ></el-input>
        </el-form-item>
        <el-form-item label="分组说明" prop="Content">
          <el-input
            v-model="addGroup.Content"
            type="textarea"
            :rows="3"
            placeholder="请输入分组说明"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addGroupVisible = false">取 消</el-button>
        <el-button
          type="primary"
          :disabled="submitDisable || !addGroup.Name"
          @click="onAddGroup"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
export default {
  data() {
    const validateGroup = (rule, value, callback) => {
      if (!value.trim().match(/.+/)) {
        callback(new Error('分组名不能为空'));
      } else {
        callback();
      }
    };
    return {
      groupList: [],
      addGroupVisible: false,
      addGroup: {},
      groupRules: { Name: [{ required: true, validator: validateGroup, trigger: 'change, blur' }] },
      queryForm: { 'Name:like': '' },
      queryFormBind: { 'Name:like': '' },
      currentPage: 1,
      totalItem: 1,
      // 操作是否为修改设备分组
      isEdit: false,
      // 控制确认按钮的disable属性
      submitDisable: false,
    };
  },
  mounted() {
    this.getGroupList();
  },
  methods: {
    // 获取分组列表
    getGroupList() {
      this.$axios.get('dci/station/group',
        { params: { where: { ...this.queryForm }, page: this.currentPage } })
        .then((response) => {
          this.groupList = response.data.data;
          this.totalItem = response.data.total;
        }, (response) => {
          this.$sys.alarmResponse(response);
        });
    },
    onSubmitQuery() {
      this.queryForm = { ...this.queryFormBind };
      // changePage会监测页码的变化，自动调用getGroupList
      if (this.currentPage !== 1) {
        this.currentPage = 1;
      } else {
        this.getGroupList();
      }
    },
    // 点击新增分组
    onAddGroup() {
      this.$refs.addGroup.validate((valid) => {
        if (valid) {
          this.submitDisable = true;
          if (!this.isEdit) {
            this.$axios.post('dci/station/group', this.addGroup).then(() => {
              this.getGroupList();
              this.addGroupVisible = false;
              this.$message({
                showClose: true,
                message: '成功添加分组',
                type: 'success',
                duration: '1500',
              });
              this.submitDisable = false;
            }, (response) => {
              this.submitDisable = false;
              this.$sys.alarmResponse(response);
            });
          } else {
            this.$axios.put(`dci/station/group/${this.addGroup.ID}`, this.addGroup).then(() => {
              this.getGroupList();
              this.addGroupVisible = false;
              this.$message({
                showClose: true,
                message: '成功修改分组',
                type: 'success',
                duration: '1500',
              });
              this.submitDisable = false;
            }, (response) => {
              this.submitDisable = false;
              this.$sys.alarmResponse(response);
            });
          }
        }
      });
    },
    // 删除分组
    onDeleteGroup(id) {
      this.$confirm('请确认是否将分组删除?', '删除分组', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$axios.delete(`dci/station/group/${id}`).then(() => {
          this.getGroupList();
          this.$message({
            type: 'success',
            message: '分组删除成功!',
          });
        }, (response) => {
          this.$sys.alarmResponse(response);
        });
      }).catch(() => { });
    },
    // 重置新增分组dialog
    resetAddGroup() {
      this.isEdit = false;
      this.addGroup = { name: '', content: '' };
      this.$refs.addGroup.resetFields();
      this.addGroupVisible = false;
    },
    onEditClient(data) {
      this.isEdit = true;
      this.addGroupVisible = true;
      this.addGroup = _cloneDeep(data);
    },
    // 翻页
    changePage(page) {
      this.currentPage = page;
      this.getGroupList();
    },
  },
};
</script>
